/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_AugustInputs */

const es_months_august = /** @type {(inputs: Months_AugustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agosto`)
};

const en_months_august = /** @type {(inputs: Months_AugustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`August`)
};

/**
* | output |
* | --- |
* | "August" |
*
* @param {Months_AugustInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_august = /** @type {((inputs?: Months_AugustInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_AugustInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_august(inputs)
	return en_months_august(inputs)
});
export { months_august as "months.august" }